module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/access-management/users/user-details/user-details.component.scss
// module id = ./src/app/access-management/users/user-details/user-details.component.scss
// module chunks = access-management.module